import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import RonIcon from '../icons/RonIcon';
import EuIcon from '../icons/EuIcon';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { COLORS2 } from '../../constants';

const useStyles = makeStyles(() => ({
    buttonGroup: {
        backgroundColor: COLORS2.darkGreen,
        borderRadius: '4.75rem',
        padding: '0.25rem',
    },
}));

export const CustomButtonGroupCurr = ({billEur, handleCurrencySelect}) => {

    const classes = useStyles();

    return(
        <ToggleButtonGroup className={classes.buttonGroup} onChange={handleCurrencySelect}>
            <ToggleButton
                style={{
                    color: billEur ? COLORS2.virtualBackground : COLORS2.darkGreen,
                    backgroundColor: billEur ? COLORS2.darkGreen : COLORS2.virtualBackground,
                    width: '6.375rem',
                    height: '2.5rem',
                    borderRadius: '4.75rem',
                    border: 'none',
                    marginRight: '0.1rem',
                }}
                checked={billEur}
                value="ron"
            >
                <RonIcon
                    style={{ width: '2rem', height: '2rem', marginRight: '0.75rem' }}
                />
                <span style={{ marginRight: '1.25rem' }}>RON</span>
            </ToggleButton>
            <ToggleButton
                style={{
                    color: billEur ? COLORS2.darkGreen : COLORS2.virtualBackground,
                    backgroundColor: billEur ? COLORS2.virtualBackground : COLORS2.darkGreen,
                    width: '6.375rem',
                    height: '2.5rem',
                    borderRadius: '4.75rem',
                    border: 'none',
                }}
                checked={billEur}
                value="eur"
            >
                <EuIcon style={{ width: '2rem', height: '2rem', marginRight: '0.75rem' }} />
                <span style={{ marginRight: '1.25rem' }}>EUR</span>
            </ToggleButton>
        </ToggleButtonGroup>
    );
};